import React, {useEffect, useState } from 'react';
import ActivityLoader from '../Common/ActivityLoader';
import BsModal from '../Common/BsModal';
import { useTheme } from '../../DataStore/ThemeContext';
import Notification from '../Common/Notification';
import { useStaff } from '../../DataStore/StaffContext';
import TextInput from '../Common/TextInput';
import { useReport } from '../../DataStore/ReportContext';
import ajaxReport from '../../util/remote/ajaxReport';

const AlertSetReportComment = () => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();
    const [teacherId, setTeacherId] = useState("");
    const [remark, setRemark] = useState("");
    const {listing, getStaffMembers} = useStaff();
    const {commentWriter, setCommentWriter} = useReport();
    useEffect(() => {
        getStaffMembers();
    }, []);



    const onChangeTeacher=(option)=>setTeacherId(option.value)

    if (!commentWriter.comment) return null;

    

    const RenderTeacher=()=>{

        const optionsListing=[];

        if(Array.isArray(listing))
        {
            listing.map((item, key)=>
            optionsListing.push({label:item.last_name + " " + item.first_name, value:item.staff_id})
            )
            }

            return(
                <TextInput
                    label={commentWriter.comment.comment.title}
                    leftIcon="fa fa-user"
                    type="select" 
                    placeholder="Select staff...." 
                    options={optionsListing}
                    onChange={onChangeTeacher}
                    leftComponent={<i className="fa fa-user txt-primary"/>}
                    wrap
            />
                
            )
            
     }

     const RenderWriter=()=>{
        return (
            <TextInput
                    label={commentWriter.comment.comment.title}
                    leftIcon="fa fa-comment"
                    type="textarea" 
                    placeholder="Write comment here..." 
                    value={remark}
                    onChange={(e)=>{setRemark(e.target.value)}}
                    leftComponent={<i className="fa fa-comment txt-primary"/>}
                    wrap
            />
        )
     }

     const handleClose = () => setCommentWriter({ show: false, comment: null, callback: null });


   
     const confirm=async()=>{
       setLoading(true);
       let server_response;
        if(commentWriter.comment.comment.scope.id * 1 === 1){
                        server_response = await ajaxReport.addCommentStaff(commentWriter.comment.id, teacherId);

        }
        else{
            server_response = await ajaxReport.writeGeneralReportComment(commentWriter.comment.id, remark);
        }
         setLoading(false);
        if(server_response.status==="OK"){
            commentWriter.callback();
             setNotify(<Notification type='success' message={server_response.message}/>)
        }else{
            setNotify(<Notification type="danger" message={server_response.message}/>)
        }
        handleClose();

    }

    return (
        <BsModal
            show={commentWriter.show}
            onClose={handleClose}
            title={`${commentWriter.comment.comment.scope.id * 1 === 1 ? "Set teacher initials" : "Write Field Comment"}`}
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Close
                    </button>
                    <button className="btn btn-danger" onClick={confirm} disabled={loading}>
                        Set Comment
                    </button>
                    </>}
                </>
            }
        >

            {commentWriter.comment.comment.scope.id * 1 === 1 ? RenderTeacher() : RenderWriter()}
          

        </BsModal>
    );
};

export default AlertSetReportComment;
